import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'
import LowerNavbar from '../../learning/california/california_classes';
import Uganda from './uganda';
import Uganda_p4_subjects from './uganda_p4_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_p4 = ( ) => {
 
  return (
    <>
   <TopNavbar />
    <Uganda />
    <International_countries />
  <Uganda_p4_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_p4;
